import { createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card-button ${$props.cardBackground}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleClick'))),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('handleClick')), ["enter"])),
    tabindex: "0"
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-button-icon" }, [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M12 5V19M5 12H19",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ])
    ], -1)),
    _createElementVNode("span", {
      class: "card-button-caption",
      innerHTML: $props.name
    }, null, 8, _hoisted_1)
  ], 34))
}